"use client";

import { motion } from "framer-motion";
import { Plane, Users, Briefcase } from "lucide-react";

export default function HomeHero() {
  return (
    <main className="relative flex flex-col items-center text-center bg-black text-white overflow-hidden">
      {/* Background cockpit image (pre-darkened) */}
      <img
        src="/Cockpit-Dark.jpg"
        alt="Cockpit background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />

      {/* Hero Content */}
      <div className="relative z-10 w-full px-6 pt-20 pb-2">
        <img
          src="/Flightpath-Main-Logo.png"
          alt="Flightpath Mentoring Logo"
          className="mx-auto mb-6 w-72 md:w-96"
        />
        <p className="text-lg md:text-xl text-white max-w-2xl mx-auto">
          Accelerate progress in your life skills, professional practices, leadership and career.
        </p>
      </div>

      {/* Three mentoring boxes */}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-6 px-6 pb-4 max-w-6xl w-full text-center">
        {/* Aspiring Pilots */}
        <motion.div whileHover={{ scale: 1.05 }} className="bg-neutral-900 rounded-xl shadow-lg p-6">
          <Plane className="text-amber-400 w-10 h-10 mb-4 mx-auto" />
          <h3 className="text-xl font-bold text-amber-400 uppercase mb-2">Aspiring Pilots</h3>
          <p className="text-gray-300">
            Plan your route to the flight deck with clear guidance, realistic costings, and support at every stage.
          </p>
        </motion.div>

        {/* Leadership Mentoring */}
        <motion.div whileHover={{ scale: 1.05 }} className="bg-neutral-900 rounded-xl shadow-lg p-6">
          <Users className="text-amber-400 w-10 h-10 mb-4 mx-auto" />
          <h3 className="text-xl font-bold text-amber-400 uppercase mb-2">Leadership Mentoring</h3>
          <p className="text-gray-300">
            Improve reflective ability, situational awareness and other core traits of effective leadership through mentoring support.
          </p>
        </motion.div>

        {/* For Organisations */}
        <motion.div whileHover={{ scale: 1.05 }} className="bg-neutral-900 rounded-xl shadow-lg p-6">
          <Briefcase className="text-amber-400 w-10 h-10 mb-4 mx-auto" />
          <h3 className="text-xl font-bold text-amber-400 uppercase mb-2">For Organisations</h3>
          <p className="text-gray-300">
            Programmes that upskill your people, improve leadership, strengthen succession planning and inspire teams with fresh, aviation-driven insights.
          </p>
        </motion.div>
      </div>
    </main>
  );
}
